<template>
    <v-container>
                  <p class="headline">Order Summary</p>
          <p class="overline">Shipping and additional costs are calculated based on values you have entered.
          </p>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
              <tr>
                <td>Order Subtotal</td>
                <td class="text-right" style="width: 50px;">Ksh {{ totalPrice }}</td>
              </tr>
              <tr>
                <td>Shipping Charges</td>
                <td class="text-right" style="width: 50px;">Ksh 10.00</td>
              </tr>
              <tr>
                <td>Tax</td>
                <td class="text-right" style="width: 50px;">Ksh {{ taxCompliance }}</td>
              </tr>
              <tr>
                <td>Total</td>
                <td class="text-right" style="width: 50px;"><b>Ksh {{ taxInclusivePrice }}</b></td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          <div class="text-center">
            <v-btn class="primary white--text mt-5" outlined @click="goHome">SHOP MORE</v-btn>
            <v-btn class="primary white--text mt-5" outlined v-if="cartCount >0 ">PROCEED TO PAY</v-btn>
          </div>
    </v-container>
</template>

<script>
export default {
    name: 'TheOrderSummary',
    computed: {
      totalPrice(){
        return Number(this.$store.getters.cartTotal)
        },
        taxCompliance(){
          return Number(16/100 * this.totalPrice).toFixed(2)
        },
        taxInclusivePrice(){
          return this.totalPrice + Number(this.taxCompliance)
        },
        cartCount(){
          return (this.$store.getters.cartItems).length
        }
      },
      methods:{
        goHome(){
          this.$router.push("/")
        }
      }
}
</script>


// WEBPACK FOOTER //
// src/components/Cart/TheOrderSummary.vue